module.exports = __webpack_public_path__ + "piscina.8ff606cd89e228a568c84fb2382ae989.jpg";